import { useAtomValue } from "jotai";
import { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { isAgentAtom } from "@/utils/atoms";

export const AgentOnlyRoute: FC = () => {
  const isAgent = useAtomValue(isAgentAtom);

  if (!isAgent) {
    return <Navigate to="/portal/cockpit" replace />;
  }

  return <Outlet />;
};
